import React from "react";
import { StarFilled } from '@ant-design/icons';
import { Tag, Spin, Tooltip } from 'antd';
import { getPreviewUrl } from '../../utils/utils';

const iconFontSize = "15px";

export const getPreviewComponent = (slide, is_cloud, isMobile) => {
    let previewPath = slide.preview_image;

    if (is_cloud === false) {
        previewPath = previewPath.replace("/static/", "");
        previewPath = getPreviewUrl(previewPath.replace('stitched_small_viewer', 'selection_marked'), slide);
    }
    return <img
        width={isMobile ? 100: 200}
        alt="logo"
        src={previewPath}
    />
}

export const getLabelComponent = (slide, is_cloud, isMobile) => {
    let labelPath = slide.preview_image;

    if (is_cloud === false) {
        labelPath = labelPath.replace("/static/", "");
        labelPath = getPreviewUrl(labelPath.replace('stitched_small_viewer', 'barcode_crop'), slide);
    }

    return <img
        height={96}
        alt="barcode-does-not-exist"
        src={labelPath}
    />
}

export const getNameComponentCaseSlide = (slide) => {
    return <span>{slide.name}</span>
}

export const getTagsComponent = (slide) => {
    return (
        <div>
            {slide.tags.map((tag, index) => {
            const isLongTag = tag.length > 20;
            let color = 'magenta';
            const tagElem = (
                <Tag key={tag} color={color}>
                {isLongTag ? `${tag.slice(0, 20)}...` : tag}
                </Tag>
            );
            return isLongTag ? <Tooltip title={tag} key={tag}>{tagElem}</Tooltip> : tagElem;
            })}
        </div>
        );
}


export const getStarredComponent = (slide) => {
    return (
        <StarFilled
            style={{ color: slide.starred === true ? "#f5667b" : "", fontSize: iconFontSize, padding: 5, display: 'inline-table' }} />
    );
}

export const getIntegersfromString = (string) => {
    let matches = string.match(/([0-9]+)/g)
    if (matches == null) {
        return 0
    }
    return matches[0]
}

export const getLexicographicalSorting = (allSlides) => {
    return Object.keys(allSlides).sort(
        function (a, b) {
            return allSlides[a].name.localeCompare(allSlides[b].name);
        }
    )
}

export const getReverseLexicographicalSorting = (allSlides) => {
    return Object.keys(allSlides).sort(
        function (a, b) {
            return allSlides[b].name.localeCompare(allSlides[a].name);
        }
    )
}

export const getNumericalSorting = (allSlides, getIntegersfromString) => {
    return Object.keys(allSlides).sort(
        function (a, b) {
            return getIntegersfromString(allSlides[a].name) - getIntegersfromString(allSlides[b].name);
        }
    )
}

export const getChronologicalSorting = (allSlides) => {
    return Object.keys(allSlides).sort(
        function (a, b) {
            return new Date(allSlides[a].date).getTime() - new Date(allSlides[b].date).getTime();
        }
    )
}

export const getReverseChronologicalSorting = (allSlides) => {
    return Object.keys(allSlides).sort(
        function (a, b) {
            return new Date(allSlides[b].date).getTime() - new Date(allSlides[a].date).getTime();
        }
    )
}